import { render, staticRenderFns } from "./GovernmentSlide.vue?vue&type=template&id=0736fde4"
import script from "./GovernmentSlide.vue?vue&type=script&lang=js"
export * from "./GovernmentSlide.vue?vue&type=script&lang=js"
import style0 from "./GovernmentSlide.vue?vue&type=style&index=0&id=0736fde4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports